import { NoteType } from '@notes/models/note-type';
import type { MediaKind } from 'src/.graphql/types';
import type { GetPublicSearchShareByCodeQuery } from '../queries/GetPublicSearchShareByCode.gql';
import type { PublicAgent } from '../models/public-agent';
import type { ShareNote, ShareView } from '../models/share-view';

export type PublicSearchShare = NonNullable<GetPublicSearchShareByCodeQuery['publicSearchShare']['byCode']>;

type PublicSearchPublicAgent = NonNullable<PublicSearchShare['agent']>;

export function toShareView(share: PublicSearchShare): ShareView {
    const { criteria, prefs } = share;

    return {
        code: share.code,
        listingIds: share.listingIds,
        connectionId: share.connectionId || null,
        createdAt: new Date(share.createdAt),
        expiresAt: share.expiresAt ? new Date(share.expiresAt) : null,
        category: share.category,
        customer: share.customer ? { fullName: share.customer.fullName } : null,
        agent: share.agent ? toPublicAgent(share.agent) : null,
        criteria: criteria ?? null,
        prefs: {
            personalizedHeader: {
                enabled: prefs.personalizedHeaderEnabled,
                title: prefs.headerTitle ?? '',
                subtitle: prefs.headerSubtitle ?? ''
            },
            includeListingInsights: prefs.includeListingInsights,
            includeListingContacts: prefs.includeListingContacts,
            includeListingNotes: prefs.includeListingNotes
        },
        sortValue: share.sortValue ?? null,
        mediaType: (share.mediaType as MediaKind | null) ?? null,
        pageSize: share.pageSize ?? null,
        insightsNarrative: share.insightsNarrative ?? null
    };
}

function toPublicAgent(agent: PublicSearchPublicAgent): PublicAgent {
    return {
        fullName: agent.fullName,
        title: agent.title ?? null,
        companyName: agent.companyName ?? null,
        companyLogoUrl: agent.companyLogoUrl ?? null,
        photoUrl: agent.profileImageUrl ?? null,
        phones: agent.phones.map(phone => ({ type: phone.type, text: phone.text })),
        email: agent.email ?? null
    };
}
